import { pick } from 'lodash-es'
import { logger } from '@ahaslides-product/frontend-toolkit'

// Set of socket actions to ignore in logging
const IGNORED_SOCKET_ACTIONS = new Set([
  'create-reaction',
  'server_timestamp',
  'chat:new-message',
])

const MESSAGE_FIELDS = ['type', 'action']
const KEPT_FIELDS = ['id', 'slideId', 'slideActive', 'activeSlide', 'presentationId', 'createdBy', 'userId', 'accessCode', 'uniqueAccessCode', 'quizStatus']

const LogWebsocketSubscriber = {
  init: (socket) => {
    const socketLog = logger.extend('socket')
    socket.onAny((eventName, ...args) => {
      // Skip logging for ignored socket actions
      if (IGNORED_SOCKET_ACTIONS.has(eventName)) {
        return
      }

      const loggedArgs = args.flatMap((arg) => {
        if (typeof arg === 'number') {
          return [arg]
        }
        if (!arg || typeof arg !== 'object' || Array.isArray(arg)) {
          return []
        }
        const loggedArg = pick(arg, [...MESSAGE_FIELDS, ...KEPT_FIELDS])
        const data = arg.data && typeof arg.data === 'object' ? pick(arg.data, KEPT_FIELDS) : {}
        if (Object.keys(data).length > 0) {
          loggedArg.data = data
        }
        return [loggedArg]
      })
      socketLog(eventName === socket.id ? 'slideState' : `${eventName}`, loggedArgs)
    })
  },
}

export default LogWebsocketSubscriber
